var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "60-lock",
    id: "_60-lock"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 14,
    rx: 2,
    ry: 2,
    width: 20,
    x: 6,
    y: 17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,1h0a8,8,0,0,1,8,8v8a0,0,0,0,1,0,0H8a0,0,0,0,1,0,0V9A8,8,0,0,1,16,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,5h0a4,4,0,0,1,4,4v8a0,0,0,0,1,0,0H12a0,0,0,0,1,0,0V9A4,4,0,0,1,16,5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1b7a29104696f04442cd37d8c740b5f1.svg";
export { ForwardRef as ReactComponent };